import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { SliceType } from '../types';
import { MoreSettingsState as State } from './types';

const INITIAL_CONFIGS = {
  clauseTagsAccessMode: [],
  importedJobId: null,
  showImportWizard: false,
};

export const initialState: State = {
  action: null,
  configs: INITIAL_CONFIGS,
};

export default createSlice({
  name: SliceType.MoreSettings,
  initialState,
  selectors: {
    selectAction: (state: State) => state.action,
    selectConfiguration: (state: State) => state.configs,
  },
  reducers: {
    setAction: (state, action: PayloadAction<State['action']>) => {
      state.action = action.payload;
    },

    setConfigs: (state, action: PayloadAction<State['configs']>) => {
      state.configs = action.payload;
    },

    resetConfiguration: (state) => {
      state.configs = INITIAL_CONFIGS;
      state.action = null;
    },
  },
});
